var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuVeritcalDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3,
    height: 15,
    viewBox: "0 0 3 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "overflow-menu-vertical",
    transform: "translate(-15.75 -6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M18.75,8.25a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,18.75,8.25Z",
    transform: "translate(0 0)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M18.75,17.25a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,18.75,17.25Z",
    transform: "translate(0 -3)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M18.75,26.25a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,18.75,26.25Z",
    transform: "translate(0 -6)",
    fill: "#ffffff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuVeritcalDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MenuVeritcalDark.37d7f4bc5f3fce2ecd705bbd1e52f489.svg";